import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMuatan } from "../../config/api/apiServices";

import {
  GridComponent,
  ColumnDirective,
  ColumnsDirective,
  Inject,
  Filter,
  Page,
  Toolbar,
  PdfExport,
  ExcelExport,
  Grid,
  SelectionSettingsModel,
  Search,
  CommandColumn,
} from "@syncfusion/ej2-react-grids";

const GridTableMuatan = (props) => {
  console.log(props);
  const filterOption: FilterSettingModel = {
    ignoreAccent: true,
    type: "Menu",
  };

  let grid: Grid | null;
  const toolbarClick = (args: any) => {
    if (grid) {
      if (args.item.id.includes("pdfexport")) {
        grid.pdfExport({ fileName: "pemakaian kapal.pdf" });
      } else if (args.item.id.includes("excelexport")) {
        grid.excelExport({ fileName: "pemakaian kapal.xlsx" });
      }
    }
  };

  const selectionOptions: SelectionSettingsModel = {
    mode: "Row",
  };

  // let navigate = useNavigate();

  // const rowSelected = () => {
  //   if (grid) {
  //     const selectedRowIndexes: number[] = grid.getSelectedRowIndexes();
  //     console.log(selectedRowIndexes);
  //     // navigate(`/Kontainer/${selectedRowIndexes}`);
  //   }
  // };

  let navigate = useNavigate();
  let nokapal = "";
  let nokont = "";
  let nobapb = "";
  let jnsservice = "";
  const rowSelected = () => {
    if (grid) {
      let a = grid.getSelectedRecords()[0].no_kapal;
      let b = grid.getSelectedRecords()[0].no_kont;
      let c = grid.getSelectedRecords()[0].no_bapb;
      let d = grid.getSelectedRecords()[0].jns_service;
      nokapal = a;
      nokont = b;
      nobapb = c;
      jnsservice = d;
    }
  };

  const [data, setData] = useState();
  useEffect(() => {
    getMuatan(props.nokapal, props.nokont).then((data) => {
      setData(data);
    });
  }, [props.nokapal, props.nokont]);

  const commands = [
    {
      // type: "Edit",
      buttonOption: {
        iconCss: " e-icons e-play",
        cssClass: "e-flat",
        click: () => {
          // alert(jnsservice);
          if (jnsservice === "K") {
            navigate(`/bapb/${nokapal}/${nokont}/${nobapb}`);
          } else {
            navigate(`/bapbm/${nokapal}/${nokont}/${nobapb}`);
          }
        },
      },
    },
  ];

  return (
    <div>
      <GridComponent
        height="100%"
        width="100%"
        dataSource={data}
        ref={(g) => (grid = g)}
        allowFiltering={true}
        filterSettings={filterOption}
        allowPaging={true}
        toolbar={["PdfExport", "ExcelExport", "Search"]}
        allowPdfExport={true}
        allowExcelExport={true}
        toolbarClick={toolbarClick}
        selectionSettings={selectionOptions}
        rowSelected={rowSelected}
        // recordDoubleClick={doubleClick}
      >
        <ColumnsDirective>
          <ColumnDirective
            // field="id"
            // headerText="ID"
            // textAlign="center"
            commands={commands}
            width="50"
          />
          <ColumnDirective
            field="id"
            headerText="ID"
            // textAlign="center"
            width="100"
          />

          {/* <ColumnDirective
            field="no_kapal"
            headerText="NO. KAPAL"
            // textAlign="center"
            width="140"
          />
          <ColumnDirective
            field="no_kont"
            headerText="NO. KONTAINER"
            // textAlign="center"
            // width="100"
          /> */}
          <ColumnDirective
            field="no_bapb"
            headerText="NP. BAPB"
            // textAlign="center"
            width="150"
          />
          <ColumnDirective
            field="kd_muatan"
            headerText="KODE"
            textAlign="center"
            width="100"
          />
          <ColumnDirective
            field="kd_penerima"
            headerText="PENERIMA"
            textAlign="center"
            width="100"
          />
          <ColumnDirective
            field="jns_service"
            headerText="JNS SERV"
            textAlign="center"
            width="100"
          />
        </ColumnsDirective>
        <Inject
          services={[
            Filter,
            Page,
            Toolbar,
            PdfExport,
            ExcelExport,
            Search,
            CommandColumn,
          ]}
        />
      </GridComponent>
    </div>
  );
};

export default GridTableMuatan;
